import MuiDivider from '@mui/material/Divider';
import { Colors } from 'styles';

export const Divider = (props: Record<any, any>): React.ReactElement => (
  <MuiDivider
    {...props}
    sx={{
      backgroundColor: Colors.gray4,
    }}
  />
);
